import { Col, Row } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ChatComponent from "../../components/ChatComponent";
const FeedbackDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state?.data;


  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-start mx-1 lg:mx-8 mb-6">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Message Details
              </h3>
            </div>
          </div>

          <Row justify="center" className="mx-2 lg:mx-8">
            <Col xs={24} sm={24} md={20} lg={16} xl={14}>
              <ChatComponent id={id} data={data} />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FeedbackDetail;
